export default "__VITE_ASSET__z0su4C9L__"